import { useAppSelector } from '~/redux/hooks'

/**
 * Returns whether the current survey requires a contact email.
 * True when both `isSurveyAnonymous` and `shouldCreateUserBeforeSurveyFlow`
 * feature flags are enabled in the survey config.
 */
export function useRequiresEmail(): boolean {
  return useAppSelector(
    state =>
      (state.currentSurvey?.surveyConfig.isSurveyAnonymous ?? false) &&
      (state.currentSurvey?.surveyConfig.shouldCreateUserBeforeSurveyFlow ??
        false),
  )
}
